import type {
  SourceImport,
  SourceImportWire,
  SourceImportsPage,
  SourceImportsPageWire,
  Submission,
  SubmissionWire,
  SubmissionsPage,
  SubmissionsPageWire,
} from '@/features/uploads/types/uploads';

type NormalizedSubmission<T extends SubmissionWire> = Omit<T, 'declaredBytes' | 'receivedBytes'> &
  Pick<Submission, 'declaredBytes' | 'receivedBytes'>;

/** Byte counters are decimal strings on the wire and numbers in upload state. */
export function toSubmission<T extends SubmissionWire>(response: T): NormalizedSubmission<T> {
  return {
    ...response,
    declaredBytes: Number(response.declaredBytes),
    receivedBytes: Number(response.receivedBytes),
  };
}

export function toSubmissionsPage(response: SubmissionsPageWire): SubmissionsPage {
  return { ...response, items: response.items.map(toSubmission) };
}

type NormalizedSourceImport<T extends SourceImportWire> = Omit<T, 'attempts'> &
  Pick<SourceImport, 'attempts'>;

/** A null counter means the import has not made its first attempt. */
export function toSourceImport<T extends SourceImportWire>(response: T): NormalizedSourceImport<T> {
  return { ...response, attempts: response.attempts ?? 0 };
}

export function toSourceImportsPage(response: SourceImportsPageWire): SourceImportsPage {
  return { ...response, items: response.items.map(toSourceImport) };
}
